import React, { Component } from "react";
const galiDash = <img src="assets/images/bg/gali-dash.svg" alt="Plugify Gali" />

class AboutOne extends Component {
    render() {
        return (
            <div className="bg-about-gali" >
                <div className="row" style={{ paddingTop: 120 }}>
                    <div className="container">
                        <div className="row">
                            <div className='col-lg-5'>
                                {galiDash}
                            </div>
                            <div className="col-lg-5">
                                <div className="" style={{
                                    textAlign: 'left',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'left',
                                    color: '#000',
                                    fontWeight: 100
                                }}>
                                    {/* <div className='bgTitleApple'>
                                        <span className="subtitle subtitleApple">Plataforma de gestão</span>
                                    </div> */}
                                    <h1 className="inner"
                                        style={{
                                            fontSize: 40,
                                            fontWeight: 900,
                                            fontFamily: 'Montserrat',
                                            textAlign: 'left',
                                            color: '#000',
                                            lineHeight: '45px'
                                        }}>
                                        Gali é a sua plataforma self service em gestão<br /> de TI e pessoas
                                    </h1>
                                    <p className="inner"
                                        style={{
                                            lineHeight: '25px'
                                        }}>
                                        <br />
                                        Desenvolvido pela Plugify para você e sua empresa terem em mãos o controle completo da sua TI.<br /> <br />
                                        De fácil operação, em poucos cliques, você encontrará diversas funcionalidades que oferecem maior autonomia no monitoramento do seu parque.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )

    }
}
export default AboutOne;
